import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  containerBackground: {
    background: `blue url(/images/auth-background.png) no-repeat center`,
    backgroundSize: 'cover',
    minHeight: '100vh'
  },
  flexQuestions: {
    marginTop: 24,
    marginRight: 24,
    width: '100%'
  },
  white: {
    color: token.colorWhite
  },
  childrenContainer: {
    maxWidth: '650px',
    width: 'calc(100% - 32px)',
    marginInline: 'auto'
  },
  footer: {
    marginBottom: 20
  },
  card: {
    '.ant-card-body': {
      padding: 56
    }
  },
  form: {
    marginTop: 24
  }
}))
